import Urls from "./Urls";

/**
 * convenience Wrapper für das Zusammenbauen von URLs
 */
export default class UrlFluid {

    protocol = undefined;
    server = undefined;
    path = undefined;
    keyValues = undefined;
    hashPart = undefined;

    constructor(url) {
        Object.assign(this, Urls.urlSplit(url));
    }

    addPath(path) {
        this.path = this.path.ensureRight('/') + path;
        return this;
    }

    param(keyUnencoded,valueUnencoded) {
        const key = encodeURIComponent(keyUnencoded);
        const value = _.isString(valueUnencoded) ? encodeURIComponent(valueUnencoded) : valueUnencoded;
        const kv = this.keyValues.find(kv=>kv[0]==key);
        if (kv) {
            kv[1] = value;
        } else {
            this.keyValues.push([key,value]);
        }
        return this;
    }

    removeParam(keyUnencoded) {
        const key = encodeURIComponent(keyUnencoded);
        this.keyValues = this.keyValues.filter(kv=>kv.key!=key);
    }

    get params() {
        return this.keyValues.map(([key,value])=>([decodeURIComponent(key),decodeURIComponent(value)]));
    }

    set params(value) {
        return this.keyValues = value.map(([key,value])=>([encodeURIComponent(key),encodeURIComponent(value)]));
    }

    toString() {
        return Urls.urlJoin(this);
    }

}